<template>
    <transition name="fade">
        <div v-if="show_overlay" class="fixed inset-0">
            <div class="fixed inset-0 bg-black bg-opacity-50 pointer-events-none"></div>
            <div
                class="absolute top-4 right-4 w-1/3 bg-white rounded-xl pt-5 pb-10 px-10 text-birdie-dark text-lg shadow-xl font-jakarta">
                <img src="/img/logo-black-website.svg" width="110" alt="Logo" class="" />
                <div class="flex items-center gap-x-3 mt-10">
                    <span>1. Click the puzzle icon above</span>
                    <span class="h-5 w-5">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"
                            style="pointer-events: none; display: block; width: 100%; height: 100%;">
                            <path
                                d="M352-120H200q-33 0-56.5-23.5T120-200v-152q48 0 84-30.5t36-77.5q0-47-36-77.5T120-568v-152q0-33 23.5-56.5T200-800h160q0-42 29-71t71-29q42 0 71 29t29 71h160q33 0 56.5 23.5T800-720v160q42 0 71 29t29 71q0 42-29 71t-71 29v160q0 33-23.5 56.5T720-120H568q0-50-31.5-85T460-240q-45 0-76.5 35T352-120Zm-152-80h85q24-66 77-93t98-27q45 0 98 27t77 93h85v-240h80q8 0 14-6t6-14q0-8-6-14t-14-6h-80v-240H480v-80q0-8-6-14t-14-6q-8 0-14 6t-6 14v80H200v88q54 20 87 67t33 105q0 57-33 104t-87 68v88Zm260-260Z" />
                        </svg>
                    </span>
                </div>
                <div class="flex items-center gap-x-3 mt-4">
                    <span>2. Pin Birdie for faster access</span>
                    <span class="h-5 w-5">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"
                            style="pointer-events: none; display: block; width: 100%; height: 100%;">
                            <path
                                d="m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Zm-286 80h252l-46-46v-314H400v314l-46 46Zm126 0Z" />
                        </svg>
                    </span>
                </div>
                <div class="flex items-center mt-10">
                    <img src="/img/pin-extension.png" class="w-full rounded-lg" alt="Pin Extension" />
                </div>
                <div class="flex items-center mt-10">
                    <jet-secondary-button class="w-full font-bold justify-center" @click="done" style="height:42px">
                        Done
                    </jet-secondary-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import JetSecondaryButton from '@/Jetstream/SecondaryButton'

export default {
    components: {
        JetSecondaryButton,
    },
    props: {
        is_extension_loaded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isPinned: false,
            pinStateKnown: false,
            extension_loaded: this.is_extension_loaded || window.extension_loaded || false,
            pollingTimeout: null,
            doneClicked: false,
        }
    },
    created() {
        document.addEventListener('EXTENSION_RESPONSE', this.handleExtensionResponse);
    },
    mounted() {
        if (this.is_chrome) {
            document.dispatchEvent(new CustomEvent('GET_EXTENSION_STATE', {
                detail: {}
            }));
        } else {
            this.$emit('close')
        }
    },
    beforeUnmount() {
        document.removeEventListener('EXTENSION_RESPONSE', this.handleExtensionResponse);
        if (this.pollingTimeout) {
            cleartimeout(this.pollingTimeout);
        }
    },
    methods: {
        done() {
            this.doneClicked = true
            this.$emit('close')
        },
        handleExtensionResponse(response) {
            // console.log('handleExtensionResponse', response)
            this.extension_loaded = true
            window.extension_loaded = true
            this.isPinned = response.detail.isPinned
            window.extension_pinned = response.detail.isPinned
            this.pinStateKnown = true
            if (!this.isPinned) {
                this.startPollingPinned()
            } else {
                this.$emit('close')
            }
        },
        startPollingPinned() {
            if (this.pollingTimeout) {
                clearTimeout(this.pollingTimeout);
            }
            this.pollingTimeout = setTimeout(() => {
                document.dispatchEvent(new CustomEvent('GET_EXTENSION_STATE', {
                    detail: {}
                }));
            }, 1000);
        },
    },
    computed: {
        is_chrome() {
            const ua = navigator.userAgent;
            const vendor = navigator.vendor;
            return ua.includes("Chrome") && vendor === "Google Inc.";
        },
        show_overlay() {
            return this.is_chrome && this.extension_loaded && this.pinStateKnown && !this.isPinned && !this.doneClicked
        }
    },
}
</script>

<style scoped>
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
